import { createAsyncThunk } from '@reduxjs/toolkit';

import api, { handleApiError } from 'state/api';

export const getAppSettingsApi = createAsyncThunk(
  'appSettings/get',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('app-settings');
      const body = response.data;
      if (!body.success) {
        return rejectWithValue({ message: body.message || 'Could not load app settings' });
      }
      return body.data;
    } catch (error) {
      return handleApiError('getAppSettingsApi', error, rejectWithValue);
    }
  },
);

export const updateAppTimezoneApi = createAsyncThunk(
  'appSettings/updateTimezone',
  async (timezone, { rejectWithValue }) => {
    try {
      const response = await api.put('app-settings/timezone', { timezone });
      const body = response.data;
      if (!body.success) {
        return rejectWithValue({ message: body.message || 'Could not update timezone' });
      }
      return body.data;
    } catch (error) {
      return handleApiError('updateAppTimezoneApi', error, rejectWithValue);
    }
  },
);
